<div class="transfer-item">
  <div class="icon-badge">
    <img [src]="getImagePath()" [alt]="item.type" class="purchase-icon" [title]="item.type">
  </div>

  <div class="product-information">
    <p>{{item.transactionId}}</p>
    <p class="transaction-title">{{item.title}}</p>
    <p>{{item.lotNo}}</p>
  </div>

  <div class="access-pass-information">
    <p>{{item.accessPassOwner}}</p>
    <p>{{item.accessPassNo}}</p>
    <p>{{item.accessPassCostCenter}}</p>
  </div>

  <div class="transaction-time">
    <p>{{item.time | date: 'yyyy-MM-dd HH:mm'}}</p>
  </div>

  <div class="transaction-price">
    <p class="font-weight-bold">{{item.price + ' ' + item.priceUnit}}</p>
  </div>
</div>
